import { FormSection } from "components/MainSectionTemplate/types";
import React from "react";
import { RadioGroup } from "components/Atoms/inputs/RadioGroup";
import { getReminderFields } from "./reminders";

interface Props {
  instruction: server.dto.UpdateClientConfigurationInstruction
  onDeleteLastReminder: () => void;
  onAddReminder: () => void;
}


const hasESignActivated = (instruction: server.dto.UpdateClientConfigurationInstruction) =>
  instruction.eSignEnabled === "legacyAndESign" || instruction.eSignEnabled === "onlyESign";

const hasOnlyLegacy = (instruction: server.dto.UpdateClientConfigurationInstruction) =>
  instruction.eSignEnabled === "onlyLegacy";

export const ESignSection = (props: Props): FormSection => {
  return {
    key: "esignSettings",
    type: "regular",
    title: RESX.ESign.eSign,
    fields: [{
      key: "esign_enabled",
      label: RESX.EmbedWizard.Display,
      render: () => <div>{esignOptions.find(option => option.value === props.instruction.eSignEnabled).label}</div>,
      hidden: !hasOnlyLegacy(props.instruction) && !site.isImpersonated,
      inPageEdit: {
        render: ({ onChange, value }) => <div className="main-section-template-fields-padding">
          <RadioGroup
            orientation="horizontal"
            options={esignOptions}
            value={value}
            onChange={v => onChange(v, true)}
          />
        </div>,
        type: "custom",
        initialValue: props.instruction.eSignEnabled,
        submitChange: (value: server.dto.ESignEnabled) => {
          return window.CoreApi.ClientConfiguration.Update({ ...props.instruction, eSignEnabled: value });
        }
      }
    },
    {
      key: "esign_reminders_header",
      label: "",
      hideLabel: true,
      hidden: !hasESignActivated(props.instruction),
      render: () => <h3>{RESX.Reminder.xReminder}</h3>
    },
    ...getReminderFields({
      instruction: props.instruction,
      reminderIntervalProp: "eSignReminderInterval",
      isHidden: !hasESignActivated(props.instruction),
      keyPrefix: "esign",
      onTrashClick: props.onDeleteLastReminder,
      onAddReminderClick: props.onAddReminder,
      maxReminders: serverReference.constants.eSign.maxReminders,
      maxReminderInterval: serverReference.constants.eSign.maxReminderInterval
    })
    ]
  }
}

interface ESignOption {
  value: server.dto.ESignEnabled
  label: string
};

const esignOptions: ESignOption[] = [{
  value: "onlyLegacy",
  label: "Only classic workflow (no eSign)"
}, {
  value: "legacyAndESign",
  label: "Classic workflow and eSign"
}, {
  value: "onlyESign",
  label: "Only eSign"
}];